import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CPQComponent } from '../../Pricing/cpq/cpq.component';
import { CPQSelectionSummary, CPQUI } from '../../shared/models/CPQUI';
import { Distributor } from '../../shared/models/Distributor';
import { Item } from '../../shared/models/Item';
import { ItemPricing } from '../../shared/models/ItemPricing';
import { Quote } from '../../shared/models/Quote';
import { QuoteDetail } from '../../shared/models/QuoteDetail';
import { ShipTo } from '../../shared/models/ShipTo';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { ItemSearchComponent } from '../../shared/components/popups/item-search/item-search.component';
import { EditSpLineComponent } from '../../shared/components/popups/edit-sp-line/edit-sp-line.component';
import { Territory } from '../../shared/models/Territory';
import { SalesPerson } from '../../shared/models/SalesPerson';
import { AfterContentInit } from '@angular/core';
import { EditFeeComponent } from '../../shared/components/popups/edit-fee/edit-fee.component';
import { Fee } from '../../shared/models/Fee';
import { faPenToSquare, faX } from '@fortawesome/free-solid-svg-icons';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { FormControl } from '@angular/forms';
import { formatCurrency } from '@angular/common';
import { QuoteReport } from '../../shared/models/QuoteReport';

@Component({
  selector: 'app-edit-quote',
  standalone: false,
  templateUrl: './edit-quote.component.html',
  styleUrl: './edit-quote.component.css'
})
export class EditQuoteComponent implements OnInit, AfterViewInit, AfterContentInit {
  //@ViewChild('cC') custCityInput: HTMLInputElement;
  //@ViewChild('cAd') custAddrInput: HTMLInputElement;
  //@ViewChild('cZ') custZipInput: HTMLInputElement;
  //@ViewChild('cS') custStateInput: HTMLInputElement;
  //@ViewChild('cCu') custCountryInput: HTMLInputElement;
  readonly EffectiveDateControl = new FormControl(new Date());
  readonly ExpirationDateControl = new FormControl(new Date());
  public IsCreate: boolean;
  public Customers: Distributor[];
  public SelectedCustomer: Distributor;
  public ShipToCustomers: ShipTo[];
  public SelectedShipTo: ShipTo;
  public CurrentQuote: Quote;
  public CurrentCPQSessionID: string;
  public hideLoadingModal: boolean;
  //public CurrentConfigString: string;
  public CurrentCPQMessages: string[];
  //public ItemList: Item[];
  public CurrentUser: User;
  public CurrentDist: Distributor;
  public ContactName: string;
  public SelectedTerritory: Territory;
  public PreparedBy: string;
  public SelectedRSM: SalesPerson;
  public SelectedAE: string;
  public SalesSupport: string;
  public IncludeCustomerNote: boolean;
  public CustomerNote: string;
  public AEs: string[];
  public Territories: Territory[];
  public RSMs: SalesPerson[];
  public IsDirectCustomer: boolean;
  faX = faX;
  faEdit = faPenToSquare;

  public constructor(private global: GlobalService, private router: Router, private http: HttpService, public matDialog: MatDialog) {

    this.IsCreate = true;
    this.hideLoadingModal = true;
    var curNavigation = this.router.getCurrentNavigation();
    if (curNavigation) {
      var stateObject = curNavigation.extras.state;
      if (stateObject) {
        if (stateObject.CurrentQuote) {
          this.CurrentQuote = <Quote>stateObject.CurrentQuote;
          this.IsCreate = false;
        }
      }
    }
    if (this.IsCreate) {
      this.CurrentQuote = new Quote();
      this.SelectedShipTo = new ShipTo();
      this.SelectedCustomer = new Distributor();
      var curDate = new Date();
      this.CurrentQuote.ExpirationDate = new Date(curDate.setDate(curDate.getDate() + 60));

    }

  }

  ngAfterViewInit() {
    //this.custAddrInput.readOnly = true;
    //this.custCityInput.readOnly = true;
    //this.custZipInput.readOnly = true;
    //this.custStateInput.readOnly = true;
    //this.custCountryInput.readOnly = true;

    //setTimeout(() => {
    //  this.custAddrInput.readOnly = false;
    //  this.custCityInput.readOnly = false;
    //  this.custZipInput.readOnly = false;
    //  this.custStateInput.readOnly = false;
    //  this.custCountryInput.readOnly = false;
    //}, 200);

  }

  ngAfterContentInit() {



  }

  async ngOnInit() {
    
    this.SelectedTerritory = new Territory();
    this.SelectedRSM = new SalesPerson();
    this.SelectedCustomer = new Distributor();
    this.IsDirectCustomer = false;
    this.SelectedAE = "";
    const mainAsync = async () => {
      const promises = [];
      promises.push(this.LoadTerritories());
      promises.push(this.LoadSalesPeople());
      promises.push(this.LoadDistributors());
      promises.push(this.GetCurUser());
      promises.push(this.GetCurDist());
      promises.push(this.GetFees());
      await Promise.all(promises);

      return;
    }

    await mainAsync();

    if (this.CurrentUser.IsTolomaticUser) {
      if (!this.IsCreate) {
        this.SelectedCustomer = this.Customers.filter(d => d.CstaccountNumber == this.CurrentQuote.CustomerNumber)[0];
      } else {
        if (this.CurrentDist) {
          this.SelectedCustomer = this.CurrentDist;
        }
        else {
          this.global.getCurrentDist().then(x => {
            this.CurrentDist = x;
            this.SelectedCustomer = this.CurrentDist;
            this.hideLoadingModal = true;
          });
        }
        var preSelTerritory = this.Territories.filter(x => x.ServiceRep == this.CurrentUser.SLUsername);
        if (preSelTerritory != null && preSelTerritory.length > 0) {
          this.CurrentQuote.TerritoryCode = preSelTerritory[0].TerritoryCode;
        }
      }
    } else if (this.CurrentUser != null) {
      this.SelectedCustomer = this.Customers.filter(d => d.CompanyId == this.CurrentUser.DistributorId)[0];

      if (this.IsCreate) {
        this.CurrentQuote.CustomerName = this.SelectedCustomer.Company;
        this.CurrentQuote.CustomerNumber = this.SelectedCustomer.CstaccountNumber;
        this.CurrentQuote.CustomerSequence = 0;
        this.CurrentQuote.TakenBy = this.CurrentUser.FirstName + " " + this.CurrentUser.LastName;
      }

      //this.http.GetShipTos(this.SelectedCustomer.CompanyId).then(ship => {
      //  this.ShipToCustomers = <ShipTo[]>ship.Content;
      //  if (!this.IsCreate) {
      //    this.SelectedShipTo = this.CurrentQuote.S
      //  }
      //});

      this.hideLoadingModal = true;

    }
    else {
      this.SelectedCustomer = this.CurrentDist;
      this.CurrentQuote.CustomerName = this.SelectedCustomer.Company;
      this.CurrentQuote.CustomerNumber = this.SelectedCustomer.CstaccountNumber;
      this.CurrentQuote.CustomerSequence = 0;
      this.hideLoadingModal = true;
    }

    this.IsDirectCustomer = this.IsDirectCustType();
    if (!this.CurrentUser || this.CurrentUser == null) {
      this.router.navigate(['/']);
    } else {
      this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Quote", "Edit/Create", "", this.CurrentUser.IsTolomaticUser ? this.SelectedCustomer.CompanyId : this.CurrentUser.DistributorId);
      this.hideLoadingModal = true;
    }


  }

  IsDirectCustType(): boolean {
    return this.SelectedCustomer.CustType.indexOf("HD") == 0;
  }

  async GetCurUser(): Promise<void> {
    await this.global.getCurrentUser().then(user => {
      this.hideLoadingModal = false;
      this.CurrentUser = user;
      //this.LoadDistributors();
    });
  }

  async GetCurDist(): Promise<void> {
    await this.global.getCurrentDist().then(dist => {
      this.CurrentDist = dist;
    });
  }

  async LoadDistributors(): Promise<void> {
    await this.global.GetDistList().then(x => {

      this.Customers = x;

    });
  }

  async GetFees(): Promise<void> {
    if (this.CurrentQuote && this.CurrentQuote.QuoteRowPointer && this.CurrentQuote.QuoteRowPointer != "00000000-0000-0000-0000-000000000000") {
      this.http.GetQuoteFees(this.CurrentQuote.QuoteRowPointer).then(x => {
        if (x.StatusCode == "200") {
          this.CurrentQuote.QuoteFees = <Fee[]>x.Content;
        }
      });
    }
  }

  async LoadTerritories(): Promise<void> {
    this.http.GetTerritories().then(x => {
      this.Territories = <Territory[]>x.Content;
      this.Territories = this.Territories.sort((a, b) => {
        return a.TerritoryName.localeCompare(b.TerritoryName);
      });

      if (this.CurrentQuote != null && this.CurrentQuote.TerritoryCode != "" && this.CurrentQuote.TerritoryCode != null) {
        this.SelectedTerritory = this.Territories.filter(x => x.TerritoryCode == this.CurrentQuote.TerritoryCode)[0];
      } else {
        this.SelectedTerritory = new Territory();
      }
    });
  }

  Territory_Change(ev: any) {
    this.CurrentQuote.TerritoryCode = ev.value;
    this.SaveQuote();
  }

  async LoadSalesPeople(): Promise<void> {
    this.http.GetSalesPeople().then(x => {
      this.RSMs = <SalesPerson[]>x.Content;
      this.RSMs = this.RSMs.sort((a, b) => {
        return a.Name.localeCompare(b.Name);
      })
      if (this.CurrentQuote != null) {
        if (this.CurrentQuote.Salesman != "" && this.CurrentQuote.Salesman != null) {
          this.SelectedRSM = this.RSMs.filter(x => x.SlsPersonID == this.CurrentQuote.Salesman)[0];
        } else {
          this.SelectedRSM = new SalesPerson();
        }
      }
    });
  }

  RSM_Change(ev: any) {
    this.CurrentQuote.Salesman = ev.value;
    this.SaveQuote();
  }

  AE_Change(ev: any) { }

  Customer_Change(ev: any) {
    if (this.IsCreate) {
      this.SelectedCustomer = this.Customers.filter(x => x.CompanyId == ev.value)[0];
    }
    //this.ShipToCustomers = this.SelectedCustomer.ShipTos;
  }

  ShipTo_Change(ev: any) {

  }

  SaveQuote() {
    this.CurrentQuote.CustomerName = this.SelectedCustomer.Company;
    this.CurrentQuote.ShipToName = this.SelectedCustomer.Company;
    this.CurrentQuote.CustomerNumber = this.SelectedCustomer.CstaccountNumber;
    this.CurrentQuote.CustomerSequence = 0;
    
    this.CurrentQuote.EffectiveDate = this.EffectiveDateControl.value;
    this.CurrentQuote.ExpirationDate = this.ExpirationDateControl.value;
    this.CurrentQuote.UpdatedBy = this.CurrentUser.FirstName + " " + this.CurrentUser.LastName;
    this.http.SaveQuote(this.CurrentQuote).then(x => {
      //this.CurrentQuote.QuoteNumber = x.Content
      this.CurrentQuote = <Quote>x.Content;
    });
  }

  AddLine() {
    var newLine = new QuoteDetail();

    this.CurrentQuote.QuoteDetails.push(newLine);
  }

  AddSP() {
    var dialogConfig = {
      width: '300px',
      height: '150px'
    };
    var currentDialog = this.matDialog.open(EditSpLineComponent, dialogConfig);
    var newSPDetail = new QuoteDetail();
    newSPDetail.LineType = 'sp';
    currentDialog.componentInstance.CurrentSPDetail = newSPDetail;
    currentDialog.componentInstance.ItemSelectEmitter.subscribe(item => {
      item.QuoteNumber = this.CurrentQuote.QuoteNumber;
      this.CurrentQuote.QuoteDetails.push(item);
      this.AssignLineNumbers();
      this.SaveQuote();
      currentDialog.close();
    });


    currentDialog.componentInstance.CloseEventEmitter.subscribe((event) => {
      currentDialog.close();
    });
  }

  EditSP(spDetail: QuoteDetail) {
    var dialogConfig = {
      width: '60%',
      height: '80%'
    };
    var currentDialog = this.matDialog.open(EditSpLineComponent, dialogConfig);
    currentDialog.componentInstance.CurrentSPDetail = spDetail;
    currentDialog.componentInstance.ItemSelectEmitter.subscribe(item => {
      this.CurrentQuote.QuoteDetails.push(item);
      this.AssignLineNumbers();
      this.SaveQuote();
      currentDialog.close();
    });


    currentDialog.componentInstance.CloseEventEmitter.subscribe((event) => {
      currentDialog.close();
    });
  }

  Add8Digit() {
    this.SearchForItem();
  }

  SearchForItem() {
    var dialogConfig = {
      width: '60%',
      height: '80%'
    };
    var currentDialog = this.matDialog.open(ItemSearchComponent, dialogConfig);
    currentDialog.componentInstance.EnteredItemNumber = "";
    currentDialog.componentInstance.UseGivenDistributor = true;
    currentDialog.componentInstance.CurrentDist = this.SelectedCustomer;
    currentDialog.componentInstance.ItemSelectEmitter.subscribe(item => {
      if (item) {

        this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Create Quote", "Item Search", item.Item, this.CurrentUser.IsTolomaticUser ? this.SelectedCustomer.CompanyId : this.CurrentUser.DistributorId);
        //this.PriceItem(item.Item);
        this.PriceConfigured(item.Item, 0.0, []).then(x => {

          //x.BuildPricing();
          var newQD = new QuoteDetail();
          newQD.QuoteNumber = this.CurrentQuote.QuoteNumber;
          newQD.AssemblyDetails = [item.Description];
          newQD.Item = item.Item;
          newQD.LineType = "8d";
          newQD.BuildPricing(x.EffectivePricing, true);

          this.CurrentQuote.QuoteDetails.push(newQD);
          this.AssignLineNumbers();
          this.SaveQuote();
          currentDialog.close();
        });

      }
    });

    currentDialog.componentInstance.CloseEventEmitter.subscribe((event) => {
      currentDialog.close();
    });
  }

  AddFee() {
    var dialogConfig = {
      width: '600px',
      height: '200px'
    };
    var currentDialog = this.matDialog.open(EditFeeComponent, dialogConfig);
    currentDialog.componentInstance.IsCreate = true;
    currentDialog.componentInstance.CurrentFee = new Fee();
    currentDialog.componentInstance.ItemSelectEmitter.subscribe(fee => {
      if (fee) {

        this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Create Quote", "Add Fee", fee.FeeName, this.CurrentUser.IsTolomaticUser ? this.SelectedCustomer.CompanyId : this.CurrentUser.DistributorId);

        if (this.CurrentQuote.QuoteFees == null) {
          this.CurrentQuote.QuoteFees = [];
        }
        
        this.CurrentQuote.QuoteFees.push(fee);
        this.SaveQuote();

        currentDialog.close();
      }
    });

    currentDialog.componentInstance.CloseEventEmitter.subscribe((event) => {
      currentDialog.close();
    });
  }

  EditFee(editFee: Fee) {
    var dialogConfig = {
      width: '600px',
      height: '200px'
    };
    var currentDialog = this.matDialog.open(EditFeeComponent, dialogConfig);
    currentDialog.componentInstance.IsCreate = true;
    currentDialog.componentInstance.CurrentFee = editFee;
    currentDialog.componentInstance.ItemSelectEmitter.subscribe(fee => {
      if (fee) {

        this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Create Quote", "Add Fee", fee.FeeName, this.CurrentUser.IsTolomaticUser ? this.SelectedCustomer.CompanyId : this.CurrentUser.DistributorId);

        var indexFee = this.CurrentQuote.QuoteFees.findIndex(x => x.RowPointer == fee.RowPointer);
        this.CurrentQuote.QuoteFees[indexFee] = fee;

        this.SaveQuote();
        currentDialog.close();
      }
    });

    currentDialog.componentInstance.CloseEventEmitter.subscribe((event) => {
      currentDialog.close();
    });
  }

  DeleteFee(fee: Fee) {
    if (fee.RowPointer != "00000000-0000-0000-0000-000000000000") {
      this.http.DeleteQuoteFee(fee.RowPointer).then(x => {
        if (x.StatusCode == "200") {
          var indexToRemove = this.CurrentQuote.QuoteFees.findIndex(x => { x.RowPointer == fee.RowPointer && x.FeeLine == fee.FeeLine });
          this.CurrentQuote.QuoteFees.splice(indexToRemove, 1);
          this.AssignFeeLineNumbers();
          this.SaveQuote();
        }
      });
    } else {
      var indexToRemove = this.CurrentQuote.QuoteFees.findIndex(x => { x.RowPointer == fee.RowPointer && x.FeeLine == fee.FeeLine });
      this.CurrentQuote.QuoteFees.splice(indexToRemove, 1);
      this.AssignFeeLineNumbers();
    }

  }

  RemoveLine(detail: QuoteDetail) {
    this.http.DeleteQuoteLine(detail.OrderDetailRowPointer).then(x => {
      var indexToDelete = this.CurrentQuote.QuoteDetails.findIndex(y => y.OrderDetailRowPointer == detail.OrderDetailRowPointer);
      this.CurrentQuote.QuoteDetails.splice(indexToDelete, 1);
      this.AssignLineNumbers();
      this.SaveQuote();
    });
  }
  ReconfigureDetail(detail: QuoteDetail) {
    this.ReconfigureExisting(detail.ConfigString,detail.OrderDetailRowPointer);
  }


  AssignFeeLineNumbers() {
    for (var i = 1; i < this.CurrentQuote.QuoteFees.length; i++) {
      this.CurrentQuote.QuoteFees[i - 1].FeeLine = i;
    }
  }

  ConfigureLine() {
    this.StartCPQProcess(true);
  }

  StartCPQProcess(openUI: boolean, addItem: boolean = false) {
    if (openUI) {
      this.CreateNewConfig(null);
    }
    else {
      this.http.CPQConfigureStart("", true).then(wrap => {
        //this.hideLoadingModal = false;
        this.CurrentCPQSessionID = wrap.Content;
        this.http.CPQInitialize(this.CurrentCPQSessionID).then(wrap2 => {
          this.CurrentCPQSessionID = wrap2.Content;

          this.http.CPQConfigureUpdate(this.CurrentCPQSessionID, "", "").then(wrap3 => {
            var cpqUI = <CPQUI>wrap3.Content;
            this.CurrentCPQMessages = [];
            if (this.CheckForRequired(cpqUI)) {
              var temp = this.PullPriceFromCPQUI(cpqUI);
              var messages = this.PullMessagesFromCPQUI(cpqUI);


              var selSummary = this.getSelectionSummaryFromCPQUI(cpqUI);
              var cpqConfigString = this.getConfigStringFromCPQUI(cpqUI);
              this.global.getCurrentDist().then(dist => {
                this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Edit Quote", "Price Configured Item", "", this.CurrentUser.IsTolomaticUser ? dist.CompanyId : this.CurrentUser.DistributorId);
              });

              this.PriceConfigured(cpqConfigString, temp, selSummary).then(x => {
                if (addItem) {

                  //x.BuildPricing();
                  var newQD = new QuoteDetail();
                  newQD.AssemblyDetails = selSummary;
                  newQD.ConfigString = "";
                  newQD.LineType = "cl";
                  x.EffectivePricing.UnitPrice = temp;
                  newQD.BuildPricing(x.EffectivePricing, true);
                  this.CurrentQuote.QuoteDetails.push(newQD);
                  this.AssignLineNumbers();
                  
                  this.SaveQuote();

                }
              });

            }
            else {
              this.CreateNewConfig(cpqUI);
            }

          });
        });
      });
    }
  }

  RepriceAllLines() {
    this.CurrentQuote.QuoteDetails.forEach(detail => {
      detail = this.Reprice(detail);
      if (detail.UnitPrice < 0.0) {
        //something went wrong, mark it as "needs attention"
      }

    });
  }

  Reprice(quoteDetail: QuoteDetail): QuoteDetail {
    var price = 0.0;
    this.http.CPQConfigureStart(quoteDetail.ConfigString, true).then(wrap => {
      //this.hideLoadingModal = false;
      var currentSessionID = wrap.Content;
      this.http.CPQInitialize(currentSessionID).then(wrap2 => {
        var initSessionID = wrap2.Content;

        this.http.CPQConfigureUpdate(initSessionID, "", "").then(wrap3 => {
          var cpqUI = <CPQUI>wrap3.Content;
          this.CurrentCPQMessages = [];
          if (this.CheckForRequired(cpqUI)) {
            var temp = this.PullPriceFromCPQUI(cpqUI);
            var messages = this.PullMessagesFromCPQUI(cpqUI);


            var selSummary = this.getSelectionSummaryFromCPQUI(cpqUI);
            var cpqConfigString = this.getConfigStringFromCPQUI(cpqUI);
            this.global.getCurrentDist().then(dist => {
              this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Edit Quote", "Price Configured Item", quoteDetail.ConfigString, this.CurrentUser.IsTolomaticUser ? dist.CompanyId : this.CurrentUser.DistributorId);
            });

            this.PriceConfigured(cpqConfigString, temp, selSummary).then(x => {
              //x.BuildPricing();
              quoteDetail.UnitPrice = temp;
              quoteDetail.BuildPricing(x.EffectivePricing, true);
              quoteDetail.AssemblyDetails = selSummary;
              return quoteDetail;
            });

          }
          else {
            //Setting to negative number so we know that there's an issue with it
            price = -1.0;
            quoteDetail.UnitPrice = -1.0;
            return quoteDetail;
          }

        });
      });
    });
    return null;
  }

  AddConfiguredLine() {
    this.StartCPQProcess(true, true);
  }

  getConfigStringFromCPQUI(cpq: CPQUI): string {
    var config = "";

    if (cpq && cpq.Details && cpq.Details.length > 0) {
      var filtered = cpq.Details.filter(x => x.Caption.toLowerCase() == "config string")[0];
      if (filtered) {
        config = filtered.Value;
      }
    }

    //if (config == "") {
    //  config = this.ConfigString;
    //}

    return config;
  }

  ReconfigureExisting(cfgString: string, detailRowPointer: string) {
    var dialogConfig = {
      width: '80%',
      height: '80%'
    };
    var currentDialog = this.matDialog.open(CPQComponent, dialogConfig);
    currentDialog.componentInstance.EnteredCFGString = cfgString;

   
    this.hideLoadingModal = true;
    currentDialog.componentInstance.ActionEventEmitter.subscribe((event) => {
      //this.ShowBreakPrice = false;
      var args = event;
      var newItem = new Item();
      newItem.Item = args.configString;
      this.global.getCurrentDist().then(dist => {
        this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Pricing", "Price Configured Item", newItem.Item, this.CurrentUser.IsTolomaticUser ? dist.CompanyId : this.CurrentUser.DistributorId);
      });

      var selSummaryArray = [];
      selSummaryArray = args.selectionSummary.split('<br />');
      selSummaryArray.forEach(sel => {
        sel = this.stripTags(sel);
      });
      selSummaryArray = selSummaryArray.slice(0, selSummaryArray.length - 1);
      this.PriceConfigured(newItem.Item, args.CurrentPrice, args.selectionSummary).then(x => {
        debugger;
        //x.BuildPricing();
        
        var newQD = this.CurrentQuote.QuoteDetails.filter(x => x.OrderDetailRowPointer == detailRowPointer)[0];
        newQD.LineType = "cl";
        if (newQD.ConfigString != args.configString) {
          newQD.AssemblyDetails = selSummaryArray;
        }
        newQD.ConfigString = args.configString;
        
        newQD.ListPrice = args.CurrentPrice;
        this.AssignPricing(newQD,x.EffectivePricing);

        //this.CurrentQuote.QuoteDetails.push(newQD);
        this.AssignLineNumbers();
        this.SaveQuote();
        currentDialog.close();
      });

    });

    currentDialog.componentInstance.CloseEventEmitter.subscribe((event) => {

      currentDialog.close();
    });
  }

  AssignPricing(source:QuoteDetail, pricing:ItemPricing) {
    source.BreakPrice1 = pricing.BreakPrice1;
    source.BreakPrice2 = pricing.BreakPrice2;
    source.BreakPrice3 = pricing.BreakPrice3;
    source.BreakPrice4 = pricing.BreakPrice4;
    source.BreakPrice5 = pricing.BreakPrice5;
    source.BreakQty1 = pricing.BreakQty1;
    source.BreakQty2 = pricing.BreakQty2;
    source.BreakQty3 = pricing.BreakQty3;
    source.BreakQty4 = pricing.BreakQty4;
    source.BreakQty5 = pricing.BreakQty5;
    //source.ListPrice = pricing.UnitPrice;
    source.ProductURL = pricing.ProductURL;
    source.ProductImage = pricing.ProductImageURL;

    if (source.BreakQty1 == 0) {
      //Must not be any pricing set up
      source.BreakQty1 = 1;
      source.BreakPrice1 = 0;
      source.BreakQty2 = null;
      source.BreakQty3 = null;
      source.BreakQty4 = null;
      source.BreakQty5 = null;
    }

    source.UnitPrice = pricing.UnitPrice;
    source.EstimatedLeadTimeString = pricing.EstimatedLeadTime;
    //this.EstLeadTime = pricing.EstimatedLeadTime;

    if (source.BreakPrice1 != 0) {
      source.UnitPrice1 = (source.ListPrice + ((source.BreakPrice1 / 100.00) * source.ListPrice));
    }
    else {
      source.UnitPrice1 = 0.0;
    }
    if (source.BreakPrice2 != 0) {
      source.UnitPrice2 = (source.ListPrice + ((source.BreakPrice2 / 100.00) * source.ListPrice));
    } else {
      source.UnitPrice2 = 0.0;
    }

    if (source.BreakPrice3 != 0) {
      source.UnitPrice3 = (source.ListPrice + ((source.BreakPrice3 / 100.00) * source.ListPrice));
    } else{
      source.UnitPrice3 = 0.0;
    }

    if (source.BreakPrice4 != 0 ) {
      source.UnitPrice4 = (source.ListPrice + ((source.BreakPrice4 / 100.00) * source.ListPrice));
    } else  {
      source.UnitPrice4 = 0.0;
    }

    if (source.BreakPrice5 != 0) {
      source.UnitPrice5 = (source.ListPrice + ((source.BreakPrice5 / 100.00) * source.ListPrice));
    } else  {
      source.UnitPrice5 = 0.0;
    }
  }

  CreateNewConfig(cpqUI: CPQUI) {
    var dialogConfig = {
      width: '80%',
      height: '80%'
    };
    var currentDialog = this.matDialog.open(CPQComponent, dialogConfig);
    currentDialog.componentInstance.EnteredCFGString = "";

    if (cpqUI) {
      currentDialog.componentInstance.CurrentCPQUI = cpqUI;
      currentDialog.componentInstance.CurrentCPQSessionID = this.CurrentCPQSessionID;
    }
    this.hideLoadingModal = true;
    currentDialog.componentInstance.ActionEventEmitter.subscribe((event) => {
      //this.ShowBreakPrice = false;
      var args = event;
      var newItem = new Item();
      newItem.Item = args.configString;
      this.global.getCurrentDist().then(dist => {
        this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Pricing", "Price Configured Item", newItem.Item, this.CurrentUser.IsTolomaticUser ? dist.CompanyId : this.CurrentUser.DistributorId);
      });

      var selSummaryArray = [];
      selSummaryArray = args.selectionSummary.split('<br />');
      selSummaryArray.forEach(sel => {
        sel = this.stripTags(sel);
      });
      selSummaryArray = selSummaryArray.slice(0, selSummaryArray.length - 1);
      this.PriceConfigured(newItem.Item, args.CurrentPrice, args.selectionSummary).then(x => {
        debugger;
        //x.BuildPricing();
        var newQD = new QuoteDetail();
        newQD.QuoteNumber = this.CurrentQuote.QuoteNumber;
        newQD.LineType = "cl";
        newQD.ConfigString = args.configString;
        newQD.AssemblyDetails = selSummaryArray;
        newQD.UnitPrice = args.CurrentPrice;
        newQD.BuildPricing(x.EffectivePricing, true);

        this.CurrentQuote.QuoteDetails.push(newQD);
        this.AssignLineNumbers();
        this.SaveQuote();
        currentDialog.close();
      });

    });

    currentDialog.componentInstance.CloseEventEmitter.subscribe((event) => {

      currentDialog.close();
    });
  }

  PriceConfigured(configuredString: string, configuredPrice: number, selectionSummary: string[]): Promise<Item> {
    var productRegex = /^([0-9]{8}|CC|PB|MG|LS|IMA[S]?|BC[2-4]|[A-Z]{2,3}|[A-Z][\d][A-Z])/i;
    var configReg = productRegex.exec(configuredString);
    var item = configReg[0];
    debugger;
    return this.http.GetBreakPricing(this.SelectedCustomer.CompanyId, item,configuredString).then(wrap => {
      if (wrap.StatusCode == "200") {
        if (wrap.Content) {
          //this.HideSearch = true;

          var newItem = new Item();
          newItem.Item = configuredString;
          //newItem.ConfigHasChanged = configuredString != this.CurrentConfigString && this.CurrentConfigString != "";
          //this.CurrentConfigString = "";
          //newItem.SelectionSummary = selectionSummary;
          newItem.Pricing = wrap.Content;
          newItem.Pricing.forEach(x => {
            x.UnitPrice = configuredPrice;
          });
          newItem.BuildPricing();
          //this.ItemList.push(newItem);

          //this.AssignLineNumbers();

          this.hideLoadingModal = true;
          return newItem;
        } else {
          this.hideLoadingModal = true;
          return null;
        }
        return null;
      }
      else if (wrap.StatusCode == "300" && wrap.Content == true) {
        //this.HideSearch = true;
        //this.OverrideBreakPricingRule = true;
        var newItem = new Item();
        newItem.Item = configuredString;
        //newItem.SelectionSummary = selectionSummary;


        newItem.Description = "Please contact Tolomatic to see pricing on this item.";

        newItem.EffectivePricing.OverridePricingRules = true;
        newItem.Pricing = [];
        var newPricing = new ItemPricing();
        newPricing.ItemStatus = 'O';
        newItem.Pricing.push(newPricing);

        newItem.BuildPricing();
        //this.AssignLineNumbers();
        this.hideLoadingModal = true;
        return newItem;
      }
      this.hideLoadingModal = true;
      return null;
    });
  }

  CheckForRequired(cpq: CPQUI) {
    var isValid = true;
    cpq.Pages.forEach(page => {
      page.Screens.forEach(screen => {
        screen.ScreenOptions.forEach(opt => {
          if (opt.IsRequired && (opt.Value == "")) {
            isValid = false;
          }
          else if (opt.IsValid == false) {
            isValid = false;
          }
        });
      });
    });
    return isValid;
  }

  PullPriceFromCPQUI(cpq: CPQUI): number {
    debugger;
    var priceDetails = cpq.Details.filter(x => x.Caption.toLowerCase().indexOf('price') >= 0);
    var totalPrice = 0.0;
    //priceDetails.forEach(price => {
    //  totalPrice += this.ParseCurrency(price.Value, 2);
    //});

    //this.CurrentPrice = totalPrice;
    var lastPrice = priceDetails[priceDetails.length - 1];
    if (lastPrice && lastPrice.Value) {
      return this.ParseCurrency(lastPrice.Value, 2);
      //this.ActionButtonDisabled = false;
    }
    else {
      return 0;
    }
  }

  AssignLineNumbers() {
    if (this.CurrentQuote) {
      if (this.CurrentQuote.QuoteDetails) {

        for (var i = 0; i < this.CurrentQuote.QuoteDetails.length; i++) {
          this.CurrentQuote.QuoteDetails[i].Index = i;
          this.CurrentQuote.QuoteDetails[i].QuoteLine = i + 1;
        }
      }
    }
  }

  ParseCurrency(str: string, precision: number) {
    return Number(str.slice(0, (str.indexOf('.')) + precision + 1));
  }

  getSelectionSummaryFromCPQUI(cpq: CPQUI): string[] {
    debugger;
    var summary = "";
    //var selectionArray = [];
    //cpq.SelectionSummary.forEach(ss => {
    //  if ((ss.Caption && ss.Value) && ss.Caption.length > 0 && ss.Value.length > 0 && (ss.Value != "No" && ss.Value != "None" && ss.Value != "False")) {
    //    var newSum = new CPQSelectionSummary();
    //    newSum.Caption = this.stripTags(ss.Caption);
    //    newSum.Value = ss.Value;
    //    selectionArray.push(newSum);
    //  }
    //});
    var retSelSummary = [];
    cpq.Details.forEach(detail => {

      if (detail.Caption.toLowerCase().indexOf("selection summary") < 0 && detail.Caption.toLowerCase().indexOf("price") < 0 && detail.Caption.indexOf("Note:") < 0 && detail.Value == "" && detail.Caption.length > 0) {
        summary += "<span>" + this.stripTags(detail.Caption) + "</span><br />";
        retSelSummary.push(this.stripTags(detail.Caption));
      }
    });

    if (this.CurrentCPQMessages.length > 0) {
      for (var i = 0; i < this.CurrentCPQMessages.length; i++) {
        summary += "<span>" + this.CurrentCPQMessages[i] + "</span><br />";
      }
    }


    return retSelSummary;
  }

  stripTags(input: string): string {
    return input.replace(/(<([^>]+)>)/gi, "");
  }

  PullMessagesFromCPQUI(cpq: CPQUI): string {
    debugger;
    var messages = "";
    var dupeCheck = [];
    for (var i = 0; i < cpq.Messages.length; i++) {
      if (cpq.Messages[i].Value.indexOf("Note:") >= 0) {
        if (dupeCheck.filter(x => x == cpq.Messages[i].Value).length == 0) {
          if (cpq.Messages[i].Value.toLowerCase().indexOf('config string') < 0) {
            messages += cpq.Messages[i].Value + "\r\n";
            dupeCheck.push(cpq.Messages[i].Value);
          }
        }
      }
    }
    for (var i = 0; i < dupeCheck.length; i++) {
      if (this.CurrentCPQMessages.filter(x => x == dupeCheck[i]).length == 0) {
        this.CurrentCPQMessages.push(dupeCheck[i]);
      }
    }
    var htmlRegex = /[<].*?[>]/g;//new RegExp('[<].*[>]');

    messages = messages.replace(htmlRegex, '');

    messages = messages.trimStart();
    return messages;
  }

  GetPriceBreakQTY(index: number, curQuoteDetail: QuoteDetail): string {
    var retQTYRange = "";
    if (index == 0 && curQuoteDetail.BreakQty1 > 0) {
      retQTYRange += curQuoteDetail.BreakQty1.toString() + (curQuoteDetail.BreakQty2 > 0 ? "-" + (curQuoteDetail.BreakQty2 - 1).toString() : "+").toString();
    }
    else if (index == 1 && curQuoteDetail.BreakQty2 > 0) {
      retQTYRange += curQuoteDetail.BreakQty2.toString() + (curQuoteDetail.BreakQty3 > 0 ? "-" + (curQuoteDetail.BreakQty3 - 1).toString() : "+").toString();
    }
    else if (index == 2 && curQuoteDetail.BreakQty3 > 0) {
      retQTYRange += curQuoteDetail.BreakQty3.toString() + (curQuoteDetail.BreakQty4 > 0 ? "-" + (curQuoteDetail.BreakQty4 - 1).toString() : "+").toString();
    }
    else if (index == 3 && curQuoteDetail.BreakQty4 > 0) {
      retQTYRange += curQuoteDetail.BreakQty4.toString() + (curQuoteDetail.BreakQty5 > 0 ? "-" + (curQuoteDetail.BreakQty5 - 1).toString() : "+").toString();
    }
    else if (index == 4 && curQuoteDetail.BreakQty5 > 0) {
      retQTYRange += curQuoteDetail.BreakQty5.toString() + "+";
    }

    return retQTYRange;
  }

  GetPriceBreakPrice(index: number, curQuoteDetail: QuoteDetail): number {
    var retPrice = 0.0;

    if (index == 0 && curQuoteDetail.BreakQty1 > 0) {
      retPrice += curQuoteDetail.BreakPrice1;
    }
    else if (index == 1 && curQuoteDetail.BreakQty2 > 0) {
      retPrice += curQuoteDetail.BreakPrice2;
    }
    else if (index == 2 && curQuoteDetail.BreakQty3 > 0) {
      retPrice += curQuoteDetail.BreakPrice3;
    }
    else if (index == 3 && curQuoteDetail.BreakQty4 > 0) {
      retPrice += curQuoteDetail.BreakPrice4;
    }
    else if (index == 4 && curQuoteDetail.BreakQty5 > 0) {
      retPrice += curQuoteDetail.BreakPrice5;
    }


    return retPrice;
  }

  DownloadQuote() {
    var qr = new QuoteReport();

    qr.CreateQuoteReport(this.CurrentQuote, this.SelectedCustomer.Company, this.SelectedTerritory.TerritoryName, this.SelectedRSM.Name);
  }

  GetAssDetailColumnCount(detail:QuoteDetail): number {
    if (detail.AssemblyDetails != null) {
      if (detail.AssemblyDetails.length <= 5) {
        return 1;
      }
      else {
        return 2;
      }
    }
    else {
      return 1;
    }
  }

  GetAssDetailRowCount(detail:QuoteDetail): number {
    if (detail.AssemblyDetails != null) {
      return Math.ceil(detail.AssemblyDetails.length / this.GetAssDetailColumnCount(detail));
    } else {
      return 0;
    }

  }

  GetAssDetailContent(detail: QuoteDetail, row: number, col: number) {
    var startIndex = row + (col * this.GetAssDetailRowCount(detail));

    if (detail.LineType != "sp") {
      if (startIndex > detail.AssemblyDetails.length - 1) {
        return "";
      }
      else {
        return this.stripTags(detail.AssemblyDetails.slice(startIndex, startIndex + 1)[0]);
      }
    }
    else {
      return detail.AssemblyDetails[0];
    }
  }                





  GetDateString(): string {
    var curDate = new Date();
    return curDate.toLocaleDateString(navigator.language);
  }
  GetTime(): string {
    var curDate = new Date();
    return curDate.toLocaleTimeString(navigator.language);
  }

  SetEffectiveDate(ev: MatDatepickerInputEvent<Date>) {
    this.CurrentQuote.EffectiveDate = ev.value;
  }

  SetExpirationDate(ev: MatDatepickerInputEvent<Date>) {
    this.CurrentQuote.ExpirationDate = ev.value;
  }

  async BuildReportContent(pdf: jsPDF) {
    
    
  }

  

  GetAssemblyDetails(detail: QuoteDetail): string {
    var retString = "";




    return retString;
  }

  GetProductNotes(detail: QuoteDetail): string {
    var retString = "";
    return retString;
  }

  getBase64ImageFromURL(url: string, height: number, width: number): Promise<string> {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
      img.onload = () => {
        var canvas = document.createElement("canvas");
        if (height && width) {
          var imgW = img.width;
          var imgH = img.height;
          var scale = Math.min((width / imgW), (height / imgH));
          var iwScaled = imgW * scale;
          var ihScaled = imgH * scale;
          canvas.width = iwScaled;
          canvas.height = ihScaled;

          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
        }
        else {
          canvas.width = img.width;
          canvas.height = img.height;

          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
        }

        var dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = error => {
        reject(error);
      };
      img.src = url;
    });
  }

  getBase64ImageFromURL_Sync(url: string, height: number, width: number): string {
    var img = new Image();
    img.setAttribute("crossOrigin", "anonymous");
    img.onload = () => {
      var canvas = document.createElement("canvas");
      if (height && width) {
        var imgW = img.width;
        var imgH = img.height;
        var scale = Math.min((width / imgW), (height / imgH));
        var iwScaled = imgW * scale;
        var ihScaled = imgH * scale;
        canvas.width = iwScaled;
        canvas.height = ihScaled;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
      }
      else {
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
      }

      var dataURL = canvas.toDataURL("image/png");
      return dataURL;
      //resolve(dataURL);
    };
    img.onerror = error => {
      //reject(error);
    };
    img.src = url;

    return img.onload(null);
  }
}
